<template>
  <div class="Info">
    <div class="main">
      <el-row>
        <div class="header-flew">
          <div class="header-item-one">
            <img :src="TrainerList.pic" class="header-image" />
            <p class="header-name">
              {{ TrainerList.userName
              }}<span v-show="TrainerList.education != ''" class="header-itTitle">{{
                TrainerList.education
              }}</span>
            </p>
            <div class="header-nature">
              <div class="teacher">
                <span
                  :class="[
                    TrainerList.teacherTypeShow != null ? 'header-teacher' : 'header-teachers',
                  ]"
                  >{{ TrainerList.teacherTypeShow || '' }}</span
                >
                <span v-show="TrainerList.courseFee">￥{{ TrainerList.courseFee }}/课时</span>
                <span v-show="!TrainerList.courseFee">暂无</span>
              </div>
            </div>
          </div>
          <div class="header-item-two">
            <p>
              出生日期：<span>{{ TrainerList.birthday }}</span>
            </p>
            <p>
              手机号码：<span>{{ TrainerList.phone }}</span>
            </p>
            <p>
              联系邮箱：<span>{{ TrainerList.email }}</span>
            </p>
            <p>
              常驻地区：<span>{{ TrainerList.provinceName }}-{{ TrainerList.cityName }}</span>
            </p>
          </div>
          <div class="header-item-three">
            <p>
              <span class="cr">讲师等级：</span>
              <span v-if="TrainerList.itLevel == 1">一级</span>
              <span v-if="TrainerList.itLevel == 2">二级</span>
              <span v-if="TrainerList.itLevel == 3">三级</span>
              <span v-if="TrainerList.itLevel == 4">四级</span>
              <span v-if="TrainerList.itLevel == 5">五级</span>
            </p>
            <p>
              <span class="cr">讲师所属：</span><span>{{ TrainerList.teacherTypeShow }}</span>
            </p>
            <p>
              <span class="cr">最高学历：</span><span>{{ TrainerList.education }}</span>
            </p>
            <p>
              <span class="cr">最高学历学校名称：</span><span>{{ TrainerList.school }}</span>
            </p>
          </div>
        </div>
      </el-row>
      <el-row :gutter="10" type="flex">
        <div class="content">
          <el-tabs v-model="activeName">
            <el-tab-pane label="内训师简介" name="first">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div class="html" v-html="TrainerList.itDescribe"></div>
            </el-tab-pane>
            <el-tab-pane :label="label" name="second">
              <div class="clearfix">
                <div class="CourseBox">
                  <div v-for="(item, index) in CourseData" :key="index" class="Course">
                    <div class="mid_top" :style="{ backgroundImage: `url(${item.pic})` }">
                      <span v-if="item.courseType == 0" class="videos">录播课</span>
                      <span v-if="item.courseType == 1" class="lives">直播课</span>
                      <div class="cc-mask">
                        <a class="commbtn btn-1" @click="handleroutePath(item.courseId)"
                          >查看详情</a
                        >
                      </div>
                    </div>
                    <div class="item-down">
                      <p class="call_h">
                        {{ item.courseName }}
                      </p>
                      <p class="call_w">
                        {{ item.chapterCount }}节 | 总长{{ item.durationTotal }}分钟 |
                        {{ item.academicHour }}课时
                      </p>
                    </div>
                  </div>
                </div>
                <el-pagination
                  class="pagination"
                  background
                  :current-page="pager.current"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="pager.size"
                  layout="total, prev, pager, next, sizes, jumper"
                  :total="pager.total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import to from 'await-to'
import { findByIdTrainer, trainerCourseInfo } from '@/api/teacher'
export default {
  data() {
    return {
      id: '',
      TrainerList: {},
      activeName: 'first',
      userId: this.$route.query.userId,
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      label: '',
      CourseData: [],
    }
  },
  mounted() {
    const id = this.$route.query.id
    this.id = id
    if (id) this.getTrainerInfo()
    this.getTrainerCourse()
  },
  methods: {
    async getTrainerInfo() {
      const [res, err] = await to(findByIdTrainer({ id: this.id }))
      if (err) return this.$message.warning(err.msg)
      res.data.itDescribe = res.data.itDescribe.replace(
        /<img/g,
        "<img style='max-width: 100% !important;'",
      )
      this.TrainerList = res.data
    },
    async getTrainerCourse() {
      const [res, err] = await to(
        trainerCourseInfo({
          userId: this.id,
          current: this.pager.current,
          size: this.pager.size,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.CourseData = res.data.list
      this.pager.total = res.data.total
      this.label = '主讲课程' + '(' + this.pager.total + '门' + ')'
    },
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getTrainerCourse()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getTrainerCourse()
    },
    handleroutePath(courseId) {
      this.$router.push({
        path: '/teacher/trainerCourseInfo',
        query: { courseId: courseId },
      })
    },
  },
}
</script>
<style scoped>
.header-flew {
  background: #fff;
  width: 100%;
  height: 254px;
  display: flex;
}
.header-image {
  width: 127px;
  height: 127px;
  margin: 25px 10px 0 10px;
}
.header-item-one {
  text-align: center;
  margin: 0 10px;
}
.header-name {
  margin-top: 5px;
  font-size: 18px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
  font-weight: 400;
  color: #606266;
}
.header-itTitle {
  margin-left: 6px;
  border: 1px solid #ff7b33;
  border-radius: 2px;
  font-size: 12px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
  font-weight: 400;
  text-align: center;
  color: #ff7b33;
  padding: 2px 3px;
}
.header-nature {
  margin-top: 12px;
  display: flex;
  justify-content: center;
}
.teacher {
  display: flex;
}
.teacher span {
  font-size: 14px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
  font-weight: 400;
  text-align: center;
  color: #909399;
}
.header-teacher {
  border-right: 1px solid #e2e2e2;
  padding-right: 10px;
  margin-right: 10px;
}
.header-teachers {
  border-right: none;
}
.header-item-two {
  margin-left: 40px;
  margin-top: 8px;
}
.header-item-two p {
  font-size: 14px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
  font-weight: 400;
  text-align: left;
  color: #909399;
  margin-top: 20px;
}
.header-item-two p span {
  color: #333;
}
.header-item-three {
  margin-left: 70px;
  margin-top: 8px;
}
.header-item-three p {
  font-size: 14px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
  font-weight: 400;
  color: #333;
  margin-top: 20px;
  display: flex;
}
.cr {
  display: block;
  width: 130px;
  text-align: right;
  color: #909399;
}
.content {
  width: 100%;
  margin: 20px 5px 0 5px;
  background: #fff;
}
.content >>> .el-tabs {
  margin: 0;
}
.content >>> .el-tabs__item {
  padding: 0;
  width: 130px;
  height: 60px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
  text-align: center;
  color: #333;
  font-size: 18px;
  line-height: 60px;
}
.content >>> .el-tabs__item.is-active {
  color: #e86c2c;
}
.content >>> .el-tabs__active-bar {
  height: 4px;
}
.content >>> .el-tabs__nav {
  margin-left: 20px;
}
.html {
  margin: 10px 20px;
}
.CourseBox {
  display: flex;
  flex-flow: wrap;
}
.Course {
  width: 282px;
  height: 238px;
  border: 1px solid #e2e2e2;
  margin: 25px 25px 0px 25px;
}
.Course p {
  text-align: left;
  letter-spacing: 0.5px;
  margin-left: 10px;
}
.pagination {
  margin: 30px 0;
}
.mid_top {
  position: relative;
  overflow: hidden;
  width: 282px;
  height: 145px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.cc-mask {
  background: rgba(0, 0, 0, 0.4);
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  transition: 0.3s;
  -webkit-transition: 0.3s;
}
a {
  text-decoration: none;
  cursor: pointer;
}
.commbtn {
  border-color: #fff;
  color: #fff;
  width: 120px;
  font-size: 18px;
  border: 1px solid;
  border-radius: 16px;
  display: inline-block;
  text-align: center;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
}
.btn-1 {
  left: 50%;
  margin-left: -72px;
  margin-top: -16px;
  position: absolute;
  top: 100%;
  transition: 0.3s;
  -webkit-transition: 0.3s;
}
.videos {
  display: inline-block;
  width: 56px;
  height: 22px;
  font-size: 12px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 20px;
  margin: 11px 10px;
  background: linear-gradient(270deg, #fc8622, #feac3d 35%, #fead3e 37%, #ffd257);
}
.lives {
  display: inline-block;
  width: 56px;
  height: 22px;
  font-size: 12px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 20px;
  margin: 11px 10px;
  background: linear-gradient(270deg, #46c597, #56d09a 30%, #57d19a 35%, #66da9d);
}
.item-down {
  margin-top: 15px;
  height: 70px;
}
.call_h {
  font-size: 16px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
  color: #333333;
  line-height: 18px;
  height: 40px;
}
.call_w {
  font-size: 14px;
  color: #909399;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
  margin-top: 5px;
  height: 20px;
}
.item-price {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.call_i {
  font-size: 20px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
  color: #ff583e;
}
.call_d {
  padding: 5px 10px 0 0;
  font-size: 14px;
  color: #909399;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
}
.mid_top:hover .cc-mask {
  opacity: 1;
  filter: alpha(opacity=100);
}
.mid_top:hover .commbtn {
  transform: translate(0px, -60px);
}
</style>
